import BaseListStore from 'stores/BaseListStore';
import AvStore, { AvSubmissionType, SubmissionType } from './AvSubmissionStore';
import { IDataFetchOptions } from '../../types';
import { getConditions } from 'stores/_services/filterService';
import { destroy, get, getPage } from 'stores/_services/dataService';

export default class AvSubmissionListStore extends BaseListStore<AvStore> {
    constructor() {
        super({
            itemStore: AvStore
        });
    }

    async getData({ ...args }: IDataFetchOptions = {}): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditions = getConditions(this.filter);

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                where: conditions,
                order: [this.sort, `${this.sortBy} ${this.sortDirection}`]
            }
        };

        const { data } = await getPage('avSubmissions', options);

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);
    }

    getSubmission(id: string): Promise<{ data: AvSubmissionType }> {
        return get(`avSubmissions/${id}`, {});
    }

    async deleteSubmission(id: string): Promise<any> {
        await destroy(`avSubmissions/${id}`, {});
        await this.getData({ reset: true });
    }

    getSubmissionLabel(submissionType: SubmissionType): string {
        switch (submissionType) {
            case SubmissionType.SP:
                return 'Suspected Malware';
            case SubmissionType.FP:
                return 'False Positive';
        }
    }
}
